<template>
    <Root>
        <NavBar :sectionElements="this.subSections"></NavBar>
        <Title>{{this.title}}</Title>
        <TextSection><slot></slot></TextSection>
        <FixedBox :sourceCode="this.sourceCode"></FixedBox>
        <br>
        <br>
    </Root>
</template>

<script>
import Root from "@/components/blog/Root.vue"
import NavBar from "@/components/blog/NavBar.vue"
import Title from "@/components/blog/Title.vue"
import TextSection from "@/components/blog/TextSection.vue"
import FixedBox from "@/components/blog/FixedBox.vue"

export default {
    props:{
        title:{
            default: "Title",
            type:String
        },
        subSections:{
            default: function(){return[]},
            type:Array
        },
        sourceCode:{
            default: "none",
            type:String
        }

    },
    components:{
        Root,
        NavBar,
        Title,
        TextSection,
        FixedBox
    },
    mounted:function(){
        //Automatically find subsections and update the data
        let textSectionElement = 0
        this.$el.childNodes.forEach(element => {
            //Check that object is a vue object
            if(element.__vue__!= undefined){
                if(element.__vue__.$options._componentTag=="TextSection"){
                    textSectionElement = element
                }
            }
            
            
        });
        let subSectionsList = []
        textSectionElement.__vue__.$children.forEach(element => {
            if(element.$options._componentTag=="SubHeading"){
                subSectionsList.push(element.$el)
                console.log(element.$el)
            }
        });
        this.subSections = subSectionsList
    }
}
</script>

<style scoped>

</style>